module.exports = __webpack_public_path__ + "img/20191219144226943.66e95e1c.jpg";